import requestv2 from "~/utils/http-v2";

const marketingProjectApi = {
	gets : async (params) => {
		const url = 'v2/marketing-project';
		return await requestv2.get(url, {params});
	},
	summary : async (params) => {
		const url = 'v2/marketing-project/summary';
		return await requestv2.get(url, {params});
	},
	add : async (params) => {
		const url = 'v2/marketing-project';
		return await requestv2.post(url, params);
	},
	update : async (params) => {
		const url = `v2/marketing-project/${params.id}`;
		return await requestv2.patch(url, params);
	},
	delete : async (id) => {
		const url = `v2/marketing-project/${id}`;
		return await requestv2.delete(url);
	},
	status : async (params) => {
		const url = `v2/marketing-project/status/${params.id}`;
		return await requestv2.post(url, params);
	},
	assign : async (params) => {
		const url = `v2/marketing-project/assign/${params.id}`;
		return await requestv2.post(url, params);
	},
	reactivate : async (params) => {
		const url = `v2/marketing-project/reactivate/${params.id}`;
		return await requestv2.post(url, params);
	},
	dailyLogs : async (id) => {
		const url = `v2/marketing-project/daily-log/${id}`;
		return await requestv2.get(url);
	},
	dailyLog : async (params) => {
		const url = `v2/marketing-project/daily-log/${params.id}`;
		return await requestv2.post(url, params);
	},
};

export default marketingProjectApi;
